import React, { useState, useEffect } from "react";
import axios from "axios";
import { Badge } from "react-bootstrap";
import { getApiClient } from "../../libs/axiosInstance";
import { getCurrencySymbol } from "../../libs/countryData";

export default function InventoryCard(props) {
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchItems = async () => {
      try {
        const response = await getApiClient().get("/api/items");
        setItems(response.data.slice(0, 5)); // only 5 items
      } catch (err) {
        console.error("Failed to fetch mini inventory:", err);
      }
      setLoading(false);
    };
    fetchItems();
  }, []);

  return (
    <div
      className="inventory-header"
      style={{
        width: props.width ?? "100%",
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          display: "flex",
          alignContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ flex: 1 }}>Inventory</h2>
      </div>
      <table
        className="inventory-tables"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "15px",
        }}
      >
        <thead>
          <tr style={{ textAlign: "left", borderBottom: "2px solid #ccc" }}>
            <th>Product Name</th>
            <th>Stock</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {isLoading === false && items && items.length > 0 ? (
            items.map((item) => (
              <tr key={item._id} style={{ borderBottom: "1px solid #eee" }}>
                <td>{item.name}</td>
                <td>{item.stock}</td>
                <td
                  style={{
                    fontWeight: "bold",
                    color: item.stock < 10 ? "red" : "green",
                  }}
                >
                  {item.stock < 10 ? (
                    <Badge bg="danger">Low Stock</Badge>
                  ) : (
                    <Badge color="success">In Stock</Badge>
                  )}
                </td>
              </tr>
            ))
          ) : isLoading === true ? (
            <tr>
              <td colSpan={3} style={{ textAlign: "center", padding: "20px" }}>
                <div
                  className="text-start spinner-border text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          ) : (
            <tr style={{ borderBottom: "1px solid #eee", textAlign: "center" }}>
              <td colSpan={3}>No data yet</td>
            </tr>
          )}
        </tbody>
      </table>
      {/* <ul style={{ listStyle: "none", padding: 0 }}>
          {items.map((item) => (
            <li
              key={item._id}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span style={{ flex: 1 }}>{item.name}</span>
              <span
                style={{
                  fontWeight: "bold",
                  color: item.stock < 10 ? "red" : "green",
                }}
              >
                {item.stock}
              </span>
            </li>
          ))}
        </ul> */}
    </div>
  );
}
